import type { FilePluginEditorConfig } from '@wix/ricos';
import React from 'react';

import { FILE_URLS } from './fileMockURL';
import { MockModal } from './mock-modal';
import type { OpenModalFn } from './mock-modal-context';

type FileUploadFunc = Exclude<FilePluginEditorConfig['handleFileSelection'], undefined>;

export const mockFileUploadWithModal =
  (openModal: OpenModalFn): FileUploadFunc =>
  updateEntity => {
    const items = [{ label: 'image.jpg' }, { label: 'document.pdf' }, { label: 'music.mp3' }];
    openModal(close => (
      <MockModal
        close={close}
        onConfirm={({ selected }) => {
          const name = items[selected[0]].label;
          // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
          const type = name.split('.').pop()!;
          const data = [
            {
              name,
              type,
              url: FILE_URLS[type],
              size: 150000,
              sizeInKb: '150',
            },
          ];
          setTimeout(() => updateEntity({ data }), 500);
        }}
        items={items}
      />
    ));
  };
